import { createSelector } from '@reduxjs/toolkit';
import { Pair } from 'client/voladeum/pairs/types';
import { RootState } from 'store';

const pairSlice = (state: RootState) => state.pair;

export const selectPair = createSelector([pairSlice], (state): Pair => state);
